export const SYMPTOMS = [
  { 
    id: 'sleep', 
    icon: '😴', 
    title: 'Sleep Support', 
    enabled: true 
  },
  { 
    id: 'weight', 
    icon: '⚖️', 
    title: 'Weight Support', 
    enabled: true 
  },
  { 
    id: 'immunity', 
    icon: '🛡️', 
    title: 'Immune Support', 
    enabled: true
  },
  { 
    id: 'male', 
    icon: '💪', 
    title: 'Male Vitality', 
    enabled: true
  },
  { 
    id: 'female', 
    icon: '🌸', 
    title: 'Female Balance', 
    enabled: true
  },
  { 
    id: 'digestion', 
    icon: '🌿', 
    title: 'Digestive Health Support', 
    enabled: true
  },
  { 
    id: 'hangover', 
    icon: '🍵', 
    title: 'Liver Support', 
    enabled: true
  }
];